(function ($) {
    jQuery(document).ready(function () {
        var activatedSlide = function (index){
            jQuery('.home-slider .slide-content .slide').removeClass('active');
            jQuery('.home-slider .slide-content .slide').eq(index).addClass('active');

            jQuery('.home-slider .slide-image .slide').removeClass('active');
            jQuery('.home-slider .slide-image .slide').eq(index).addClass('active');

            jQuery('.home-slider .bullets .bullet').removeClass('active');
            jQuery('.home-slider .bullets').each(function(){
                jQuery(this).find('.bullet').eq(index).addClass('active');
            });
        };

        if(jQuery('.home-slider .slide-image .slide').length){
            activatedSlide(0);

            setInterval(function(){
                let current = jQuery('.home-slider .slide-image .slide.active').index();
                current += 1;
                if(current > jQuery('.home-slider .slide-image .slide').length - 1){
                    activatedSlide(0);
                } else {
                    activatedSlide(current);
                }
            }, 5000);
        }
    });
})(jQuery);
